import { IAgentSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

export function isDeveloperCanCallback(agent: IAgentSchema | null, isPhoneSubstituted: boolean): boolean {
  return (
    !isPhoneSubstituted &&
    Boolean(agent && agent.isDeveloper && agent.availableServices && agent.availableServices.isPhoneChangingAvailable)
  );
}
